/* eslint-disable react/react-in-jsx-scope */
import {
  FiFileText,
  FiKey,
  FiMail,
  FiSmile,
  FiUser,
  FiUsers,
} from 'react-icons/fi';
import { TbCalendarMinus } from 'react-icons/tb';

export const SIGNIN_TEXT = 'Sign in';
export const SIGNUP_TEXT = 'Sign up';
export const SIGNUP_MODAL_HEADING = 'Use your email ID to create an account';
export const SIGNIN_MODAL_HEADING = 'Enter your email Id & password to login';
export const SIGNUP_MODAL_SPAN_TEXT = 'Already have an account?';
export const SIGNIN_MODAL_SPAN_TEXT = 'New here?';
export const SIGNUP_BUTTON_TEXT = 'Sign up with Email';
export const SIGNIN_BUTTON_TEXT = 'Sign In';
export const SIGNUP_GOOGLE_TEXT = 'Sign up with Google';
export const SIGNIN_GOOGLE_TEXT = 'Sign in with Google';
export const FORGOT_PASSWORD = 'Forgot Password';
export const FORGOT_PASSWORD_HEADING = 'Enter your email Id';
export const RESET_PASSWORD_HEADING = 'Enter your new password';
export const RESET_PASSWORD_BUTTON_TEXT = 'Reset Password';
export const RESEND_CODE_BUTTON_TEXT = 'Send Reset Code';
export const KANBAN_STATES = [
  'not_started',
  'in_progress',
  'in_review',
  'approved',
  'scheduled',
  'published',
];
export const PASSWORD_FORMAT =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])(?!.*\s).{8,}$/;
export const EMAIL_REGEX =
  // eslint-disable-next-line no-control-regex
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const INPUT_REGEX = /^\s*[A-Za-z][\s\S]*$/;
export const LINK_REGEX =
  // eslint-disable-next-line no-useless-escape
  /^(?:(?:https?):\/\/|www\.)[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)+[a-zA-Z0-9_\/\.\?=#&%-]*$/;

export const SelectStylesTeamView = {
  option: (styles, { isSelected, isFocused }) => {
    return {
      boxShadow: isFocused ? null : null,
      background: isSelected ? `url("./Images/blueTick.svg")` : '',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '98% 50%',
      fontSize: '14px',
      lineHeight: '24px',
      fontWeight: '500',
      color: '#344054',

      '&:hover': {
        backgroundColor: 'lightgrey',
        cursor: 'pointer',
      },
    };
  },

  control: (baseStyles) => {
    return {
      ...baseStyles,
      cursor: 'pointer',
    };
  },
};

export const SelectStyles = {
  option: (styles, { isSelected, isFocused }) => {
    return {
      boxShadow: isFocused ? null : null,
      background: isSelected ? `url("./Images/blueTick.svg")` : '',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '98% 50%',
      backgroundColor: isSelected ? '#F2F4F7!important' : '#fff',
      paddingRight: isSelected ? '0px' : '25px',
      fontSize: '14px',
      lineHeight: '24px',
      fontWeight: '500',
      color: '#344054',

      '&:hover': {
        backgroundColor: 'lightgrey',
        cursor: 'pointer',
      },
    };
  },

  control: (baseStyles) => {
    return {
      ...baseStyles,
      cursor: 'pointer',
    };
  },
};

export const PersonalViewSelectStyles = {
  option: (styles, { isSelected, isFocused }) => {
    return {
      boxShadow: isFocused ? null : null,
      background: isSelected ? `url("./Images/blueTick.svg")` : '',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '85% 50%',
      backgroundColor: isSelected ? '#F2FBFB!important' : '#fff',
      paddingRight: isSelected ? '0px' : '25px',
      fontSize: '14px',
      lineHeight: '24px',
      fontWeight: '400',
      color: '#344054',

      '&:hover': {
        backgroundColor: 'lightgrey',
        cursor: 'pointer',
      },
    };
  },

  control: (baseStyles) => {
    return {
      ...baseStyles,
      cursor: 'pointer',
    };
  },

  // Fix z-index to appear above sticky table header
  menu: (baseStyles) => {
    return {
      ...baseStyles,
      zIndex: '9999999 !important', // Maximum z-index - higher than all elements including navigation
      position: 'absolute',
    };
  },

  // Portal styles to ensure dropdown appears above everything when using menuPortalTarget
  menuPortal: (baseStyles) => {
    return {
      ...baseStyles,
      zIndex: '9999999 !important', // Maximum z-index - ensures dropdown always appears on top
    };
  },
};

export const collaborationColors = [
  '#958DF1',
  '#F98181',
  '#FBBC88',
  '#FAF594',
  '#70CFF8',
  '#94FADB',
  '#B9F18D',
];

export const dotsVerticalIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="dots-vertical">
      <g id="Icon">
        <path
          d="M10 10.832C10.4603 10.832 10.8334 10.4589 10.8334 9.9987C10.8334 9.53846 10.4603 9.16536 10 9.16536C9.53978 9.16536 9.16669 9.53846 9.16669 9.9987C9.16669 10.4589 9.53978 10.832 10 10.832Z"
          stroke="currentColor"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 4.9987C10.4603 4.9987 10.8334 4.6256 10.8334 4.16536C10.8334 3.70513 10.4603 3.33203 10 3.33203C9.53978 3.33203 9.16669 3.70513 9.16669 4.16536C9.16669 4.6256 9.53978 4.9987 10 4.9987Z"
          stroke="currentColor"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 16.6654C10.4603 16.6654 10.8334 16.2923 10.8334 15.832C10.8334 15.3718 10.4603 14.9987 10 14.9987C9.53978 14.9987 9.16669 15.3718 9.16669 15.832C9.16669 16.2923 9.53978 16.6654 10 16.6654Z"
          stroke="currentColor"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

const getRandomElement = (list) =>
  list[Math.floor(Math.random() * list.length)];
export const getRandomColor = () => getRandomElement(collaborationColors);

// API
export const API_V1 = 'api/v1';

// ROUTES
export const QUESTIONNAIRE = '/questionnaire';
export const EDITOR = '/editor';
export const FREESTYLE_EDITOR = '/freestyle-editor';
export const CONTENT_PLANNER = 'content-planner';
export const DOCUMENTS = '/library';
export const DOCUMENT = 'library';
export const FOLDER = 'folder';
export const TEAMS = 'teams';
export const TEMPLATES = 'templates';
export const IDEATE = 'ideate';
export const SUMMARIZATION = 'summarization';
export const RESEARCH = 'research';
export const DOCUMENT_HISTORY = 'documentHistory';
export const PROJECTS = 'projects';
export const PRIVACY = 'privacy';
export const TERMS = 'terms';
export const MCP = 'mcp';
export const MCP_DOCS = 'mcp/docs';
export const SUBSCRIPTION = 'subscription';
export const CONFIRM_SUBSCRIPTION = 'confirm-subscription';
export const BILLING_SUBSCRIPTION = 'billing-subscription';
export const BILLING_PAYMENT = 'billing-payment';
export const BILLING_PLAN = 'billing-plan';
export const SUBSCRIBE_PLAN = 'subscribe-plan';
export const UPDATE_PROFILE = 'update-profile';
export const ADD_CARD = 'add-card';
export const SUBSCRIPTION_PLAN = 'subscription-plan';
export const LOGIN = 'log-in';
export const SIGNUP = 'sign-up';
export const ONBOARDING = 'onboarding';
export const NEW_PLAN = '/new-plan';
export const BRAND = 'brand';
export const INTEGRATION = '/integrations';
export const LINKEDIN_CALLBACK = '/callbacks/linkedin';
export const X_CALLBACK = '/callbacks/x';

// QUESTION TITLES
export const LINK_QUESTIONS = [
  'Press kit',
  'Company website',
  'Business Website',
];
export const SUBSCRIPTION_TABLE_HEADER_TITLES = [
  {
    title: 'Invoice',
    icon: null,
    id: Math.random(),
  },
  {
    title: 'Billing date',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8 3.33203V12.6654M8 12.6654L12.6667 7.9987M8 12.6654L3.33334 7.9987"
          stroke="#475467"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    id: Math.random(),
  },
  {
    title: 'Status',
    icon: null,
    id: Math.random(),
  },
  {
    title: 'Amount',
    icon: null,
    id: Math.random(),
  },
  {
    title: 'Plan',
    icon: null,
    id: Math.random(),
  },
  {
    title: '',
    icon: null,
    id: Math.random(),
  },
];
export const TEAM_TABLE_HEADER_TITLES = [
  {
    title: 'Team Name',
    icon: <FiUsers color="#667085" size={16} />,
    id: 'team_name',
  },
  {
    title: 'Members',
    icon: <FiSmile color="#667085" size={16} />,
    id: 'members',
  },
  {
    title: 'Team Created',
    icon: <TbCalendarMinus color="#667085" size={16} />,
    id: 'team_created',
  },
  {
    title: 'Description',
    icon: <FiFileText color="#667085" size={16} />,
    id: 'description',
  },
  {
    title: '',
    icon: '',
    id: '',
  },
];
export const TEAM_MEMBER_TABLE_HEADER_TITLES = [
  {
    title: 'Name',
    icon: <FiUser color="#667085" size={16} />,
    id: 'name',
  },
  {
    title: 'Email',
    icon: <FiMail color="#667085" size={16} />,
    id: 'email',
  },
  {
    title: 'Permissions',
    icon: <FiKey color="#667085" size={16} />,
    id: 'permissions',
  },
  {
    title: 'Last Active',
    icon: <TbCalendarMinus color="#667085" size={16} />,
    id: 'last_active',
  },

  {
    title: '',
    icon: '',
    id: '',
  },
];
export const PLAN_TEAM_COUNT_MAPPING = {
  'Basic Plan': 0,
  'Pro Plan': 1,
  'Lifetime Pro Plan': 1,
  'AppSumo Tier3': 999999999,
  'Business Plan': 999999999,
  'Lifetime Business Plan': 999999999,
};

export const mentionStyle = {
  backgroundColor: '#bca6eb',
};

export const mentionsInputStyle = {
  '&multiLine': {
    highlighter: {
      padding: '13px 12px',
      border: '1px solid transparent',
      lineHeight: '18.4px',
    },
    input: {
      padding: 12,
      paddingRight: '30px',
      border: '1px solid silver',
      fontFamily: 'Inter',
      borderRadius: '6px',
    },
  },

  '&singleLine': {
    display: 'inline-block',
    width: 180,

    highlighter: {
      padding: 1,
      border: '2px inset transparent',
    },
    input: {
      padding: 1,
      border: '2px inset',
      fontFamily: 'Inter',
      borderRadius: '6px',
    },
  },

  suggestions: {
    zIndex: 999999,
    list: {
      backgroundColor: 'white',
      // border: "1px solid rgba(0,0,0,0.15)",
      fontSize: 16,
      maxHeight: 110,
      overflowY: 'auto',
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '10px',
      color: '#1D2939',
      backgroundColor: 'transparent',
      padding: '8px',
      cursor: 'pointer',
      '&focused': {
        backgroundColor: '#F9F5FF',
      },
    },
  },
};

export const TONE_OPTIONS = [
  'Friendly',
  'Formal',
  'Assertive',
  'Optimistic',
  'Informative',
  'Curious',
].map((value) => {
  return {
    value,
    label: value,
  };
});

export const STYLE_OPTIONS = [
  'Professional',
  'Conversational',
  'Humorous',
  'Empathic',
  'Simple',
  'Academic',
  'Creative',
].map((value) => {
  return {
    value,
    label: value,
  };
});

export const currencyFormat = (labelValue) => {
  // Nine Zeroes for Billions
  return Math.abs(Number(labelValue)) >= 1.0e9
    ? Math.abs(Number(labelValue)) / 1.0e9 + 'B'
    : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? Math.abs(Number(labelValue)) / 1.0e6 + 'M'
      : // Three Zeroes for Thousands
        Math.abs(Number(labelValue)) >= 1.0e3
        ? Math.abs(Number(labelValue)) / 1.0e3 + 'K'
        : Math.abs(Number(labelValue));
};

export const DocumentNotificationTypes = [
  'document_collaboration',
  'document_status_changed',
  'document_added_to_folder',
  'document_removed_from_folder',
  'accepted_document_invitation',
  'sent_document_invitation',
];

export const CommentNotificationTypes = ['comment_added', 'mentioned'];

export const TeamNotificationTypes = [
  'team_member_added',
  'team_member_removed',
  'accepted_team_invitation',
  'sent_team_invitation',
];

export const TaskNotificationTypes = ['task_assigned'];

export const FolderNotificationTypes = [
  'sent_folder_invitation',
  'accepted_folder_invitation',
  'folder_collaboration',
];

export const GOALS_OPTIONS = [
  'Make an announcement',
  'Make an impact',
  'Persuade audience',
  'Information',
  'Generate Leads',
].map((value) => {
  return {
    value,
    label: value,
  };
});

export const DEFAULT_STYLE_GUIDE = {
  voice_and_tone: {
    formality_level: '',
    perspective: '',
    inclusiveness: '',
  },
  grammar_and_mechanics: {
    active_or_passive_voice: '',
    punctuation: '',
    numbers: '',
  },
  brand_terminology: {
    product_names: '',
    industry_jargon: '',
    competitors: '',
  },
  text_formatting: {
    links: '',
    headings: '',
    lists: '',
  },
  audience_and_purpose: {
    target_audience: '',
    writing_style: '',
    objective: '',
  },
};

export const GENERATE_INNER_HTML_PROMPT_POSTFIX =
  'Please format the response in HTML and only provide body inner content, excluding the body and image tags and without wrapping it with any other quotes or strings.';

export const navigationItems = [
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M1.83616 11.4826C1.59951 11.806 1.53597 12.2177 1.66305 12.5926C1.79124 12.9685 2.09582 13.2647 2.48475 13.3928L3.40834 13.6952C3.93095 13.8675 4.28372 14.3358 4.29029 14.8661L4.30782 15.8018V15.8008C4.31329 16.1956 4.51379 16.5653 4.84685 16.7973C5.18101 17.0284 5.6094 17.0956 6.00271 16.9769L6.93177 16.7028C7.46203 16.5453 8.03722 16.7249 8.36918 17.1513L8.95313 17.8958C9.19964 18.2129 9.58747 18.3999 9.99942 18.3999C10.4114 18.3999 10.7992 18.2129 11.0457 17.8958L11.6297 17.1513C11.9616 16.7249 12.5368 16.5453 13.0671 16.7028L13.9961 16.9769C14.3905 17.0956 14.82 17.0284 15.1542 16.7952C15.4872 16.5621 15.6866 16.1914 15.691 15.7955L15.7031 14.8661H15.702C15.7129 14.3358 16.0679 13.8685 16.5905 13.6952L17.5141 13.398C17.9041 13.2689 18.2087 12.9717 18.3358 12.5957C18.4629 12.2187 18.3994 11.8071 18.1627 11.4826L17.6018 10.7212C17.2797 10.2886 17.2797 9.70892 17.6018 9.27626L18.1627 8.51492C18.3994 8.19149 18.4629 7.77982 18.3358 7.40493C18.2076 7.02899 17.903 6.73284 17.5141 6.60472L16.5905 6.30228C16.0679 6.13006 15.7151 5.6617 15.7086 5.13137L15.691 4.19569V4.19674C15.6856 3.80188 15.4851 3.43223 15.152 3.20017C14.8179 2.96914 14.3895 2.90193 13.9962 3.0206L13.0671 3.29467C12.5368 3.4522 11.9616 3.27262 11.6297 2.84626L11.0457 2.10172C10.7992 1.78458 10.4114 1.59766 9.99944 1.59766C9.58749 1.59766 9.19965 1.78458 8.95314 2.10172L8.3692 2.84626C8.03724 3.2726 7.46204 3.45218 6.93179 3.29467L6.00272 3.0206C5.60832 2.90193 5.17884 2.96914 4.84578 3.20227C4.51162 3.4354 4.31224 3.8061 4.30783 4.20201L4.29578 5.13137H4.29688C4.28592 5.6617 3.93095 6.12899 3.40834 6.30228L2.48475 6.59948C2.09473 6.72865 1.79014 7.02582 1.66305 7.40179C1.53597 7.77878 1.59951 8.19044 1.83616 8.51492L2.3971 9.27626C2.7192 9.70893 2.7192 10.2886 2.3971 10.7212L1.83616 11.4826ZM9.99928 5.51769C11.2395 5.51769 12.4282 5.99025 13.3046 6.83035C14.1811 7.67046 14.6741 8.80986 14.6741 9.99857C14.6741 11.1873 14.1811 12.3267 13.3046 13.1668C12.4282 14.0068 11.2394 14.4794 9.99928 14.4794C8.75912 14.4794 7.57034 14.0069 6.69392 13.1668C5.81751 12.3267 5.32444 11.1873 5.32444 9.99857C5.32444 8.80986 5.81745 7.67041 6.69392 6.83035C7.5704 5.9903 8.75912 5.51769 9.99928 5.51769Z"
          fill="#344054"
        />
        <path
          d="M7.89468 10.2911C8.0141 10.4056 8.06121 10.5705 8.02068 10.727L7.59341 12.3673C7.54629 12.5458 7.61532 12.7327 7.7676 12.844C7.92099 12.9553 8.12806 12.9679 8.29458 12.8766L9.76268 12.0722H9.76159C9.90949 11.9924 10.0892 11.9924 10.2371 12.0722L11.7052 12.8766C11.8706 12.9679 12.0777 12.9553 12.2311 12.844C12.3833 12.7327 12.4524 12.5458 12.4063 12.3673L11.9791 10.727H11.978C11.9374 10.5705 11.9857 10.4056 12.104 10.2911L13.0089 9.42372C13.1459 9.29246 13.1864 9.09502 13.113 8.92385C13.0385 8.75268 12.8643 8.64031 12.6704 8.64031H11.4631C11.2713 8.64031 11.0982 8.5311 11.0226 8.36202L10.4387 7.05564C10.3642 6.88657 10.1911 6.77734 9.99937 6.77734C9.80764 6.77734 9.63453 6.88656 9.56004 7.05564L8.9761 8.36202C8.9005 8.53109 8.7274 8.64031 8.53567 8.64031H7.32833C7.13441 8.64031 6.96021 8.75268 6.88572 8.92385C6.81231 9.09503 6.85285 9.29245 6.9898 9.42372L7.89468 10.2911Z"
          fill="#344054"
        />
      </svg>
    ),
    text: 'Brand Description',
    id: 'brand_description',
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M7.06001 15.8349H6.64001C3.28001 15.8349 1.60001 14.9975 1.60001 10.81V6.62258C1.60001 3.27263 3.28001 1.59766 6.64001 1.59766H13.36C16.72 1.59766 18.4 3.27263 18.4 6.62258V10.81C18.4 14.16 16.72 15.8349 13.36 15.8349H12.94C12.6796 15.8349 12.4276 15.9606 12.268 16.1699L11.008 17.8449C10.4536 18.5819 9.54641 18.5819 8.99201 17.8449L7.73201 16.1699C7.59761 15.9857 7.28681 15.8349 7.06001 15.8349Z"
          fill="#344054"
        />
        <path
          d="M13.357 9.13672H13.365"
          stroke="white"
          strokeWidth="1.68"
          strokeLinecap="round"
          strokeLineJoin="round"
        />
        <path
          d="M9.99625 9.13672H10.0043"
          stroke="white"
          strokeWidth="1.68"
          strokeLinecap="round"
          strokeLineJoin="round"
        />
        <path
          d="M6.63538 9.13672H6.64346"
          stroke="white"
          strokeWidth="1.68"
          strokeLinecap="round"
          strokeLineJoin="round"
        />
      </svg>
    ),
    text: 'Core Messaging',
    id: 'core_messaging',
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.1004 9.80073C14.04 9.80073 13.98 9.79905 13.9202 9.7957C13.8847 9.7957 13.8488 9.7957 13.8132 9.7957C12.0164 9.79568 10.2884 10.4871 8.98762 11.7267C7.68682 12.9663 6.91293 14.6589 6.82638 16.4536H20.8C20.7161 14.7083 19.982 13.0575 18.7421 11.8262C17.5022 10.595 15.8464 9.87241 14.1004 9.80073ZM7.88447 3.40924C7.62205 3.14684 7.29981 2.95211 6.94547 2.84181C6.59113 2.73151 6.2153 2.70894 5.85031 2.77604C5.48532 2.84314 5.14209 2.9979 4.85015 3.227C4.55821 3.45611 4.32629 3.75271 4.17435 4.09129C4.02241 4.42986 3.95499 4.80028 3.97789 5.17069C4.00079 5.54109 4.11333 5.90038 4.30583 6.21766C4.49832 6.53494 4.76501 6.80071 5.08295 6.9921C5.4009 7.1835 5.76058 7.2948 6.13105 7.31642C6.17736 7.31642 6.223 7.31877 6.26898 7.32045C6.72176 7.3196 7.16413 7.1846 7.54024 6.93251C7.91634 6.68042 8.20932 6.32254 8.38217 5.90405C8.55503 5.48557 8.6 5.02525 8.51142 4.58122C8.42284 4.13719 8.20467 3.72937 7.88447 3.40924ZM6.25522 7.99429C7.05525 8.02575 7.83924 8.22842 8.55429 8.58861C9.22479 8.92699 9.8212 9.39551 10.3087 9.96684C8.88429 10.7005 7.7243 11.8604 6.99048 13.2847H0.399994C0.485705 11.8519 1.11536 10.5058 2.16029 9.52161C3.20522 8.53743 4.58655 7.98943 6.02199 7.9896H6.10555C6.15522 7.99228 6.20623 7.99362 6.25522 7.99362V7.99429ZM13.9474 9.12218C14.0041 9.12218 14.0608 9.12453 14.1176 9.12655C14.8732 9.12356 15.5973 8.82341 16.1335 8.29093C16.6696 7.75846 16.9748 7.03642 16.983 6.28082C16.9912 5.52523 16.7018 4.79674 16.1773 4.25277C15.6528 3.70879 14.9353 3.393 14.1799 3.37363C13.4246 3.35426 12.6919 3.63287 12.1402 4.14925C11.5885 4.66563 11.2622 5.37833 11.2316 6.13335C11.2011 6.88838 11.4688 7.62511 11.977 8.18436C12.4851 8.74361 13.1929 9.08048 13.9474 9.12218Z"
          fill="#344054"
        />
      </svg>
    ),
    text: 'Audience',
    id: 'audience',
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="17"
        viewBox="0 0 20 17"
        fill="none"
      >
        <path
          d="M5.68178 0.826768C5.13537 0.828734 4.61636 1.02975 4.24067 1.42653C3.88756 1.79947 3.34703 2.39172 2.54143 3.31863C1.68345 4.30443 0.940731 5.17018 0.599455 5.57453C0.464797 5.73408 0.50389 5.83231 0.712573 5.8386C1.09511 5.85012 1.79034 5.85643 2.5812 5.85643H4.76769L6.89384 3.37841C8.06479 2.02149 9.03978 0.880405 9.05506 0.855132C9.07691 0.81962 6.91868 0.822317 5.68178 0.826768Z"
          fill="#344054"
        />
        <path
          d="M10.9755 0.840264C10.9602 0.860162 11.9153 1.99589 13.0917 3.36805L15.2376 5.85607H17.4188C18.2079 5.85607 18.9013 5.84947 19.2843 5.838C19.4949 5.8317 19.5342 5.73322 19.3979 5.57252C19.053 5.16574 18.3034 4.29465 17.4388 3.29828L15.999 1.63905C15.5445 1.11534 14.8857 0.813778 14.1923 0.812046L13.1377 0.809414C11.9607 0.804822 10.9855 0.820366 10.9755 0.840264Z"
          fill="#344054"
        />
        <path
          d="M7.93928 3.40555C6.81884 4.70736 5.89895 5.79267 5.88896 5.81324C5.87901 5.83314 7.72878 5.85304 9.99568 5.85304C12.268 5.85304 14.1222 5.84309 14.1222 5.82778C14.1222 5.80252 13.539 5.11909 10.8352 1.9828C10.3982 1.47004 10.0209 1.04759 10.0056 1.04298C9.99029 1.03839 9.06051 2.0983 7.93928 3.40555Z"
          fill="#344054"
        />
        <path
          d="M0.756831 6.98892C0.938212 7.18025 2.76268 9.09959 4.8183 11.2618C6.86941 13.4285 8.55767 15.1971 8.57296 15.1971C8.6028 15.1971 8.5676 15.1213 6.61295 10.8241L4.72796 6.6776L2.58202 6.66229L0.90077 6.6545C0.726289 6.65369 0.636306 6.86275 0.756831 6.98892Z"
          fill="#344054"
        />
        <path
          d="M5.63722 6.69741C5.71758 6.92394 9.98042 16.2525 10.0004 16.2525C10.0257 16.2525 14.2425 7.01892 14.3581 6.7174C14.378 6.66229 13.6142 6.65234 10.0004 6.65234C7.35154 6.65234 5.62742 6.67216 5.63722 6.69741Z"
          fill="#344054"
        />
        <path
          d="M15.2076 6.81296C15.1724 6.90327 14.3535 8.7079 13.393 10.8241C11.3319 15.3532 11.4024 15.1971 11.4277 15.1971C11.4377 15.1971 13.1267 13.4277 15.1824 11.2665C17.238 9.09977 19.0626 7.18051 19.2438 6.9891C19.3648 6.86233 19.275 6.65234 19.0997 6.65234H15.2779L15.2076 6.81296Z"
          fill="#344054"
        />
      </svg>
    ),
    text: 'Value Proposition',
    id: 'value_propositions',
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <circle cx="10" cy="9.99766" r="8.4" fill="#344054" />
        <path
          d="M12.0765 9.70024L12.0764 9.70052L11.3414 11.0297L11.1521 11.3721L11.0514 10.9941L9.84817 6.47782C9.84811 6.47761 9.84805 6.47739 9.84799 6.47717C9.81139 6.34513 9.73113 6.22409 9.61521 6.13139C9.49895 6.03843 9.35287 5.97896 9.19613 5.96276C9.03937 5.94655 8.8815 5.97463 8.74396 6.04228C8.60655 6.10988 8.49731 6.21302 8.42871 6.33591L12.0765 9.70024ZM12.0765 9.70024C12.1381 9.58833 12.2334 9.49231 12.3536 9.42431C12.4738 9.35631 12.6132 9.31955 12.7564 9.31911H16.4312C16.6374 9.31911 16.8326 9.39423 16.9745 9.52417C17.116 9.65369 17.1925 9.82623 17.1925 10.0029C17.1925 10.1795 17.116 10.3521 16.9745 10.4816C16.8326 10.6115 16.6374 10.6866 16.4312 10.6866H13.3259H13.2327L13.1878 10.7683L11.5984 13.6622L12.0765 9.70024ZM6.81171 9.23827L8.42865 6.336L11.5984 13.6623C11.5368 13.7741 11.4415 13.8701 11.3214 13.9381C11.2012 14.0061 11.0618 14.0428 10.9186 14.0433C10.9185 14.0433 10.9184 14.0433 10.9183 14.0433L10.7984 14.0433C10.644 14.0263 10.5002 13.9672 10.3854 13.8756C10.269 13.7826 10.1886 13.6612 10.152 13.5287C10.152 13.5285 10.1519 13.5283 10.1519 13.5281L8.94862 9.0117L8.84791 8.63368L8.6586 8.97603L7.9236 10.3052L7.92345 10.3055C7.86186 10.4174 7.76654 10.5134 7.64638 10.5814C7.52619 10.6495 7.38669 10.6862 7.24347 10.6866C7.24342 10.6866 7.24336 10.6866 7.24331 10.6866L3.56874 10.6866C3.36259 10.6866 3.16737 10.6115 3.02545 10.4816C2.884 10.3521 2.80749 10.1795 2.80749 10.0029C2.80749 9.82623 2.884 9.65369 3.02545 9.52417C3.16737 9.39423 3.36259 9.31911 3.56874 9.31911H6.67412H6.76666L6.81171 9.23827Z"
          fill="white"
          stroke="#344054"
          strokeWidth="0.315"
        />
      </svg>
    ),
    text: 'Tone of Voice',
    id: 'tone_of_voice',
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10.9001 10.3247V9.35547H9.10013V10.3247C9.10013 10.861 9.50213 11.2939 10.0001 11.2939C10.4981 11.2939 10.9001 10.861 10.9001 10.3247Z"
          fill="#344054"
        />
        <path
          d="M16.5997 4.82837H14.1997V3.53609C14.1997 2.46996 13.3897 1.59766 12.3998 1.59766H7.59989C6.60992 1.59766 5.79993 2.46996 5.79993 3.53609V4.82837H3.39999C2.41003 4.82837 1.60004 5.70068 1.60004 6.7668V8.05909H18.3996V6.7668C18.3996 5.70068 17.5896 4.82837 16.5997 4.82837ZM12.9998 4.82837H6.9999V3.53609C6.9999 3.18071 7.26989 2.88994 7.59989 2.88994H12.3998C12.7298 2.88994 12.9998 3.18071 12.9998 3.53609V4.82837Z"
          fill="#344054"
        />
        <path
          d="M12.1001 10.3247C12.1001 11.5718 11.1581 12.5862 10.0001 12.5862C8.84215 12.5862 7.90018 11.5718 7.90018 10.3247V9.35547H1.60043V16.4633C1.60043 17.5294 2.41042 18.4017 3.40039 18.4017H16.6001C17.59 18.4017 18.4 17.5294 18.4 16.4633V9.35547H12.1003L12.1001 10.3247Z"
          fill="#344054"
        />
      </svg>
    ),
    text: 'Industry',
    id: 'industry',
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M8.20893 9.61933C8.20893 11.5076 5.37653 11.5076 5.37653 9.61933C5.37653 7.73106 8.20893 7.73106 8.20893 9.61933Z"
          fill="#344054"
        />
        <path
          d="M9.625 1.59766C5.20162 1.59766 1.60001 5.19957 1.60001 9.62265C1.60001 11.61 2.31755 13.4841 3.62517 14.9524L1.7369 16.8407C1.60472 16.9776 1.56223 17.1806 1.63777 17.3552C1.70858 17.5346 1.88324 17.6479 2.07207 17.6479H9.62515C14.0485 17.6479 17.6501 14.046 17.6501 9.62291C17.6501 5.19983 14.0481 1.59766 9.625 1.59766ZM14.8179 11.5109C14.8179 11.7706 14.6055 11.983 14.3458 11.983C14.0862 11.983 13.8738 11.7706 13.8738 11.5109V10.5668C13.8738 10.3071 13.6613 10.0947 13.4017 10.0947H12.9296V11.5109C12.9296 11.7706 12.7172 11.983 12.4576 11.983C12.1979 11.983 11.9855 11.7706 11.9855 11.5109V10.0947H9.10589C8.88402 11.171 7.93045 11.983 6.79278 11.983C5.48987 11.983 4.43244 10.9256 4.43244 9.62265C4.43244 8.31975 5.48987 7.26232 6.79278 7.26232C7.93045 7.26232 8.88404 8.07427 9.10589 9.15059H13.4018C14.1807 9.15059 14.818 9.78788 14.818 10.5668L14.8179 11.5109Z"
          fill="#344054"
        />
      </svg>
    ),
    text: 'Keywords & Themes',
    id: 'keywords_themes',
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10Z"
          fill="#344054"
        />
        <rect
          x="4.99997"
          y="8"
          width="4.05263"
          height="4.05263"
          rx="0.578948"
          fill="white"
        />
        <path
          d="M10.2105 9.15625H16"
          stroke="white"
          strokeWidth="0.578948"
          strokeLinecap="round"
        />
        <path
          d="M10.2105 10.8984H16"
          stroke="white"
          strokeWidth="0.578948"
          strokeLinecap="round"
        />
      </svg>
    ),
    text: 'Topics',
    id: 'detailed_topics',
  },
];
